/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ParticipantPptAccessListItemDto } from '../models/PagedResultDto_ParticipantPptAccessListItemDto';
import type { Wealthlane_AdvisorApi_PptAccessListStatus } from '../models/Wealthlane_AdvisorApi_PptAccessListStatus';
import type { Wealthlane_Dtos_AdvisorApi_PptAccessListDto } from '../models/Wealthlane_Dtos_AdvisorApi_PptAccessListDto';
import type { Wealthlane_Dtos_AdvisorApi_SetParticipantPptAccessStatusInput } from '../models/Wealthlane_Dtos_AdvisorApi_SetParticipantPptAccessStatusInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PptAccessListParticipantService {

    /**
     * @param status
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ParticipantPptAccessListItemDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppPptAccessListParticipant(
        status?: Wealthlane_AdvisorApi_PptAccessListStatus,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ParticipantPptAccessListItemDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/ppt-access-list-participant',
            query: {
                'Status': status,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_Dtos_AdvisorApi_PptAccessListDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppPptAccessListParticipantSetAccessStatus(
        requestBody?: Wealthlane_Dtos_AdvisorApi_SetParticipantPptAccessStatusInput,
    ): CancelablePromise<Wealthlane_Dtos_AdvisorApi_PptAccessListDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/ppt-access-list-participant/set-access-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
